import React from 'react';

const AuthIllustration = () => {
    return (
        <div className="fixed bottom-0 left-0 w-[400px] h-[300px] z-0 pointer-events-none opacity-80" style={{ transform: 'translate(-10%, 10%)' }}>
            <svg viewBox="0 0 400 300" fill="none" xmlns="http://www.w3.org/2000/svg">
                {/* Buildings */}
                <rect x="150" y="180" width="30" height="120" rx="4" fill="#e2e8f0" opacity="0.6"/>
                <rect x="190" y="150" width="40" height="150" rx="4" fill="#cbd5e1" opacity="0.6"/>
                <rect x="240" y="120" width="35" height="180" rx="4" fill="#e2e8f0" opacity="0.6"/>
                <rect x="285" y="160" width="45" height="140" rx="4" fill="#cbd5e1" opacity="0.6"/>
                <line x1="257" y1="120" x2="257" y2="90" stroke="#f97316" strokeWidth="2" opacity="0.8"/>
                <circle cx="257" cy="88" r="3" fill="#f97316" opacity="0.8"/>
                {/* Windows */}
                <rect x="200" y="165" width="20" height="4" fill="#ffffff" opacity="0.8"/>
                <rect x="200" y="180" width="20" height="4" fill="#ffffff" opacity="0.8"/>
                <rect x="200" y="195" width="20" height="4" fill="#ffffff" opacity="0.8"/>
                <rect x="250" y="140" width="15" height="4" fill="#ffffff" opacity="0.8"/>
                <rect x="250" y="155" width="15" height="4" fill="#ffffff" opacity="0.8"/>
                <rect x="250" y="170" width="15" height="4" fill="#ffffff" opacity="0.8"/>
                {/* Plant Leaves */}
                <path d="M50 300 C40 250, 20 200, 60 180 C80 170, 70 240, 50 300 Z" fill="#93c5fd" opacity="0.9"/>
                <path d="M50 300 C60 220, 80 180, 110 160 C130 150, 90 230, 50 300 Z" fill="#60a5fa" opacity="0.9"/>
                <path d="M50 300 C80 260, 120 220, 150 240 C160 250, 110 280, 50 300 Z" fill="#fdba74" opacity="0.9"/>
                <path d="M50 300 C20 260, 10 230, -20 250 C-30 260, 10 280, 50 300 Z" fill="#bfdbfe" opacity="0.9"/>
                <path d="M50 300 C40 230, 0 170, 30 150 C50 140, 60 220, 50 300 Z" fill="#a78bfa" opacity="0.7"/>
            </svg>
        </div>
    );
};

export default AuthIllustration;
